import { pxToRem, unit, themeGet, breakpoints } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
export const customScrollbarStyles = css `
  &::-webkit-scrollbar {
    width: ${pxToRem(6)};
    height: ${pxToRem(6)};
  }

  &::-webkit-scrollbar-track {
    margin: ${unit('xl')} 0;
    border-radius: ${themeGet('borderRadius.md')};
  }

  &::-webkit-scrollbar-thumb {
    width: ${pxToRem(6)};
    height: ${pxToRem(6)};
    border-radius: ${themeGet('borderRadius.md')};
  }

  &:hover {
    &::-webkit-scrollbar-track {
      background: ${themeGet('colors.gray.50')};
    }

    &::-webkit-scrollbar-thumb {
      background: ${themeGet('colors.gray.200')};

      &:hover {
        background: ${themeGet('colors.gray.300')};
      }
    }
  }
`;
export const PageWrapper = styled.div `
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;
export const PageContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow: hidden;
`;
export const PageContent = styled.div `
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
export const DocumentContainer = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
export const DocumentPageContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  overflow: auto;
  margin: 0;
  height: 100%;
  width: 100%;

  ${breakpoints.sm} {
    margin: 0 ${unit('xl')} ${unit('xl')} ${unit('xl')};
    width: calc(100% - ${unit('xl')} * 2);

    ${customScrollbarStyles};
  }
`;
